<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="dataActionBox.boxTitle" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <!--  -->
                                    <el-table v-if="sendDataInfo.dataList.length > 0" :row-class-name="rowClassName" @row-click="rowClick" border style="width: 100%" :data="sendDataInfo.dataList" ref="mxTableRef"
                                              size="mini" :height="mxHeight / 2">
                                        <!-- 明细信息 -->
                                        <el-table-column align="center" v-for="(formOneValue) in mxForm" :key="formOneValue.psrgmId" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip
                                                         :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1">
                                            <template slot-scope="scope">
                                                <!-- 显示通用名称 -->
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo.dataList[scope.$index][formOneValue.riftField])">
                                                        {{ sendDataInfo.dataList[scope.$index][formOneValue.entityField]
                                          }}</a>
                                                </span>

                                                <span v-else>
                                                    {{ sendDataInfo.dataList[scope.$index][formOneValue.entityField] }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-table v-if="sendDataInfo.dataList.length > 0" border class="baseTable" :data="sendDataInfo.dataList[selectIndex].rdList" size="mini" :height="mxHeight / 2"
                                              ref="pschacBatchDetails">
                                        <el-table-column align="center" v-for="(formOneValue, formOneKey) in phForm" :key="formOneKey" :min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField"
                                                         :label="formOneValue.showField" v-if="formOneValue.isShow == 1">
                                            <template slot-scope="scope">
                                                <el-input v-if="formOneValue.entityField == 'rejNum'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                          v-model="scope.row[formOneValue.entityField]" type="number" :min="0" @input="calculate(scope.$index)"></el-input>
                                                <span v-else>
                                                    {{ scope.row[formOneValue.entityField] }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "retailWebPoolAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                dataList: [],
            },
            selectIndex: 0,
            showTabs: "",
            formDataList: [],
            mxHeight: 0,
            tabForm: [
                {
                    jciName: "",
                }
            ], // tab循环的主表单
            mxForm: [],
            phForm: [],
            footForm: [],
            token: {
                token: sessionStorage.getItem("token"),
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        calculate(index) {
            console.log(index);

            var info = this.sendDataInfo.dataList[this.selectIndex].rdList[index]
            var num = NP.minus(info.retailPnumber, info.refundNum)
            if (info.rejNum >= num) {
                this.sendDataInfo.dataList[this.selectIndex].rdList[index].rejNum = num
            }
        },
        rowClick(row) {
            this.selectIndex = row.index
        },
        rowClassName({ row }) {
            let rowName = ""
            if (row.index == this.selectIndex) {
                rowName = "rowStyle"
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消关闭'
                    // });
                });
        },
        init() {
            this.sendDataInfo.dataList = [];
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            this.init()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.sendDataInfo.dataList = this.$common.getIndex(JSON.parse(JSON.stringify(oldData)))
                this.selectIndex = 0
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                this.sendDataInfo.dataList = this.$common.getIndex(JSON.parse(JSON.stringify(oldData)))
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                }, 16.7);
            });
        },
        sendDataAction(sendDataInfo) {
            console.log(sendDataInfo);
            this.sub();
        },
        async sub() {
            var arr = []
            this.sendDataInfo.dataList.forEach(item => {
                arr.push({
                    pooldetailId: item.pooldetailId,
                    orderInfoList: []
                })
                if (item.rdList.length > 0) {
                    arr[arr.length - 1].orderInfoList = item.rdList.map(items => {
                        return {
                            retailDId: items.retailDId,
                            rejNum: items.rejNum || 0,
                            retailId: items.retailId,
                        }
                    })
                }
            })
            let sendData = {
                isStore: this.actionData.isStore,
                orderId: this.actionData.orderId,
                orderInfoList: arr
            }
            var responseData= await this.$http.retailWebgenOrderRej(sendData);
            if (responseData.status == 200) {
                this.init();
                this.$message.success("操作成功");
                this.$emit("drawerCancel", 1, responseData.result);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 过滤表单不同类型
        filterMainField() {
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {

                } else if (item.jciType == 2) {
                    if (item.jciId == 1800000080501) {
                        this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    } else if (item.jciId == 1800000080502) {
                        this.phForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    }
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });

        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();

        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>